import React from 'react';
import API_BASE from '../../utils/api.js';
import '../../component-styles/ManualCreditModal.css'; // or a new file

export default function RefundCreditModal({ credit, projectId, onClose, onRefunded }) {

  const confirmRefund = async () => {
    const res = await fetch(`${API_BASE}/api/credits/${projectId}/${credit.creditId}/refund`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        userid: localStorage.getItem('userId'),
      },
    });

    const data = await res.json();
    onRefunded(data);
    onClose();
  };

  return (
    <div className="manualcredit-overlay">
      <div className="manualcredit-card">
        <div className="manualcredit-head">
          <h3>Refund Credit</h3>
          <button className="manualcredit-close" onClick={onClose}>
            ×
          </button>
        </div>

        <div className="manualcredit-body">
          <p>
            You are about to refund <strong>{credit.creditNumber}</strong> for
            <strong> ${credit.availableBalance.toFixed(2)}</strong>.
          </p>
          <p style={{ marginTop: '8px' }}>
            <em>
              You must process the actual refund manually (card terminal, check, bank transfer,
              etc.). InteriorFolio will only update the credit balance.
            </em>
          </p>
        </div>

        <div className="manualcredit-footer">
          <button className="manualcredit-btn-secondary" onClick={onClose}>
            Cancel
          </button>
          <button className="manualcredit-btn-primary" onClick={confirmRefund}>
            Confirm Refund
          </button>
        </div>
      </div>
    </div>
  );
}
